import CloseIcon from "@mui/icons-material/Close";
import Alert from "@mui/material/Alert";
import IconButton from "@mui/material/IconButton";
import Slide, { SlideProps } from "@mui/material/Slide";
import Snackbar from "@mui/material/Snackbar";
import { useDispatch, useSelector } from "react-redux";
import { setAlert } from "state/slice/alert";
import { RootState } from "state/store";

type TransitionProps = Omit<SlideProps, "direction">;

function TransitionDown(props: TransitionProps) {
  return <Slide {...props} direction="down" />;
}

const CustomAlert = () => {
  const Dispatch = useDispatch();
  const alert = useSelector((state: RootState) => state.alert);

  const handleClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }

    Dispatch(setAlert());
  };

  return (
    <Snackbar
      open={alert.showAlert}
      autoHideDuration={3000}
      onClose={handleClose}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      TransitionComponent={TransitionDown}
      sx={{ zIndex: 9999999 }}
    >
      <Alert
        severity={alert?.type}
        action={
          <IconButton
            aria-label="close"
            color="inherit"
            size="small"
            onClick={handleClose}
          >
            <CloseIcon fontSize="inherit" />
          </IconButton>
        }
        className="fm-poppins"
      >
        {alert.message}
      </Alert>
    </Snackbar>
  );
};

export default CustomAlert;
